'use client';

import type { KeyboardEvent, MouseEvent } from 'react';

import { LayoutContainer, Modal } from '@petsmart-ui/sparky';
import type { ProductAsset } from '@libs/common-next';
import ProductAssetsGallery from './components/ProductAssetsGallery';
import './ProductCarousel.scss';

export type ProductAssetGalleryModalProps = {
    modalOpen: boolean;
    closeModal: () => void;
    selectedModalIndex: number;
    productName: string;
    productAssets: ProductAsset[];
};

export default function ProductAssetGalleryModal({
    modalOpen,
    closeModal,
    selectedModalIndex,
    productName,
    productAssets,
}: ProductAssetGalleryModalProps) {
    const closeContinueModal = (event: MouseEvent | KeyboardEvent) => {
        if (event) {
            event.preventDefault();
        }
        closeModal();
    };

    return (
        <Modal
            dismissible
            fullWidth
            isActive={modalOpen}
            onClose={closeContinueModal}
            ariaLabelledBy="modal-heading-1"
            ariaDescribedBy="modal-description-1"
            className="product-carousel__modal-container"
        >
            <Modal.Header className="product-carousel__modal-header" />
            <Modal.Body className="product-carousel__modal-body">
                <LayoutContainer
                    variant="narrow"
                    data-testid="product-modal-layout"
                >
                    <ProductAssetsGallery
                        wrapperProps={{
                            startAtDefault: selectedModalIndex,
                            lightbox: true,
                            className:
                                'product-carousel product-carousel-modal',
                        }}
                        productAssets={productAssets}
                        productName={productName}
                        isModalView
                    />
                </LayoutContainer>
            </Modal.Body>
        </Modal>
    );
}
